<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.employee.attendanceShift.shift') }}
      </h1>
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-8">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'attendance-shift-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end"></div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.shift_name }}</td>
          <td>{{ record.shift_type }}</td>
          <td class="text-center">{{ record.minute_allow }}</td>
          <td class="text-center">
            <span class="badge badge-success" v-if="!record.inactive">{{
              $t('yes')
            }}</span>
            <span class="badge badge-default" v-else>{{ $t('no') }}</span>
          </td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('tooltip.show')"
              class="mr-2 text-info"
              @click.prevent="show(record)"
            >
              <i class="fas fa-eye"></i>
            </a>
            <a
              href="#"
              v-tooltip="$t('tooltip.edit')"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="$t('tooltip.delete')"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import ShowComponent from './show.vue'

export default {
  name: 'attendance-shift',
  components: {
    ShowComponent
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('attendanceShift', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.attendanceShift.search
      },
      set(newValue) {
        this.$store.commit('attendanceShift/SET_SEARCH', newValue)
        this.$store.commit('attendanceShift/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('administration.employee.attendanceShift.shiftName')
        },
        {
          name: this.$t('administration.employee.attendanceShift.shiftType'),
          style: 'width:20%'
        },
        {
          name: this.$t('administration.employee.attendanceShift.minuteAllow'),
          style: 'text-align:center; width:10%'
        },
        {
          name: this.$t('administration.employee.attendanceShift.active'),
          style: 'text-align:center; width:10%'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:7%'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('attendanceShift/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    show(showData) {
      this.$modal.show(
        ShowComponent,
        {
          showData: showData
        },
        {
          height: 'auto',
          width: '60%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    edit(record) {
      this.$store.commit('attendanceShift/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'attendance-shift-edit',
        params: { id: record.shift_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('attendanceShift/destroy', record.shift_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'attendance-shift-create') {
      this.$store.commit('attendanceShift/RESET_STATE')
      this.$store.commit('attendanceShift/SET_WEEK_DAYS', [])
    }
    next()
  }
}
</script>
